

export class MRTSConnectionEvent {
}

MRTSConnectionEvent.DEPLOYMENT_SETTINGS_READY = 'DEPLOYMENT_SETTINGS_READY';
MRTSConnectionEvent.CONTENT_READY = 'CONTENT_READY';
/**
 * Dispatched by MRTSConnection whenever an s17 is received from MRTS. Contains the new scene object
 * that is about to become the current scene in the run. The SCENE_RECEIVED event occurs BEFORE the
 * scene changes or the state changes in MRTSClientAppState. Normally, the SCENE_RECEIVED event is
 * not required by applications, but serves some advanced cases that require direct access to the
 * raw scene that was delivered by MRTS before the state changes. For an example, see MegaScreen's
 * OrphanSceneMediaLoader class.
 *
 * @type {string}
 */
MRTSConnectionEvent.SCENE_RECEIVED = 'SCENE_RECEIVED';
MRTSConnectionEvent.ROOM_MODULE_MESSAGE_SENT = 'ROOM_MODULE_MESSAGE_SENT';
